// SampleCamera.jsx

import React from "react";
import WebSocketDataFeed from "./WebSocketDataFeed";

const SampleCamera = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
                Lakeshore Camera Monitoring
              </h1>
              <p className="text-slate-500 mt-1">
                Real-time person detection dashboard
              </p>
            </div>
            <div className="hidden sm:block">
              <span className="text-sm text-slate-400">
                Live Feed
              </span>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <WebSocketDataFeed />
      </div>
    </div>
  );
};

export default SampleCamera;